import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "../screens/User/Home/Home.css";
import PropTypes from "prop-types";
import "bootstrap/dist/css/bootstrap.css";
import reactlogo from "../images/reactlogo.png";
import reactlogopng from "../images/react-logo-png_2224770.png";
import redux from "../images/redux.png";
import downloadpwa from "../images/downloadpwa.png";
import downloadexpo from "../images/downloadexpo.png";
import firebaselogo from "../images/firebaselogo.png";
import gitlogo from "../images/gitlogo.png";
import pngegg from "../images/pngegg.png";
import downloadui from "../images/downloadui.png";
import Bootstrap_logo from "../images/220px-Bootstrap_logo.svg.png";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

class CaroselSection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: null,

      responsive: {
        0: {
          items: 1,
        },
        450: {
          items: 2,
        },
        600: {
          items: 3,
        },
        1000: {
          items: 5,
        },
      },
    };
  }

  render() {
    return (
      <div class="py-5">
        <div class="container text-center">
          <OwlCarousel
            // className="owl-theme"
            loop={true}
            autoplay={true}
            freeDrag={true}
            autoplayHoverPause={true}
            autoplayTimeout={1500}
            items={5}
            responsive={this.state.responsive}
            //   margin={10}
            //   {...this.state.options}

            //   nav
          >
            <div class="item">
              <img
                data-toggle="tooltip"
                data-placement="top"
                title="React"
                class="mx-auto "
                src={reactlogo}
                alt=""
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "cover",
                }}
              />
            </div>
            <div class="item">
              <img
                data-toggle="tooltip"
                data-placement="top"
                title="React Native"
                class="mx-auto "
                src={reactlogopng}
                alt=""
                style={{
                  width: "100px",
                  height: "100px",
                  //  objectFit: "cover",
                }}
              />
            </div>
            <div class="item">
              <img
                data-toggle="tooltip"
                data-placement="top"
                title="Redux"
                class="mx-auto "
                src={redux}
                alt=""
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "cover",
                }}
              />
            </div>
            <div class="item">
              <img
                data-toggle="tooltip"
                data-placement="top"
                title="Progressive Web Apps"
                class="mx-auto "
                src={downloadpwa}
                alt="Progressive Web Apps"
                style={{ width: "100px", height: "100px" }}
              />
            </div>
            <div class="item">
              <img
                data-toggle="tooltip"
                data-placement="top"
                title="Expo"
                class="mx-auto "
                src={downloadexpo}
                alt="Expo (React Native)"
                style={{ width: "100px", height: "100px" }}
              />
            </div>
            <div class="item">
              <img
                data-toggle="tooltip"
                data-placement="top"
                title="Firebase"
                class="mx-auto "
                src={firebaselogo}
                alt="Expo (React Native)"
                style={{ width: "100px", height: "100px" }}
              />
            </div>
            <div class="item">
              <img
                data-toggle="tooltip"
                data-placement="top"
                title="Git"
                class="mx-auto "
                src={gitlogo}
                alt="Expo (React Native)"
                style={{ width: "100px", height: "100px" }}
              />
            </div>
            <div class="item">
              <img
                data-toggle="tooltip"
                data-placement="top"
                title="Material UI"
                class="mx-auto "
                src={downloadui}
                alt="Expo (React Native)"
                style={{ width: "100px", height: "100px" }}
              />
            </div>
            <div class="item">
              <img
                data-toggle="tooltip"
                data-placement="top"
                title="Node JS"
                class="mx-auto "
                src={pngegg}
                alt="Expo (React Native)"
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "cover",
                }}
              />
            </div>
            <div class="item">
              <img
                data-toggle="tooltip"
                data-placement="top"
                title="Bootstrap"
                class="mx-auto "
                src={Bootstrap_logo}
                alt="Expo (React Native)"
                style={{
                  width: "100px",
                  height: "100px",
                  // objectFit: "cover",
                }}
              />
            </div>
          </OwlCarousel>
        </div>
      </div>
    );
  }
}

CaroselSection.propTypes = {
  fluid: PropTypes.bool,
  // applies .container-fluid className
};

export default withRouter(CaroselSection);
